export default __webpack_public_path__ + "static/media/card_best_performance.c6422ec1.webp";